"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompleteInformationInitRequest = void 0;
var CompleteInformationInitRequest = /** @class */ (function () {
    function CompleteInformationInitRequest() {
    }
    return CompleteInformationInitRequest;
}());
exports.CompleteInformationInitRequest = CompleteInformationInitRequest;
;
//# sourceMappingURL=completeInformationInit.request.js.map